import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import firebase from 'firebase/compat/app';
import  'firebase/compat/storage';
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAvRI19wSK8tw3g_MgPEMC4S9JI0FpzIPY",
  authDomain: "peterjustesen-37e4f.firebaseapp.com",
  projectId: "peterjustesen-37e4f",
  storageBucket: "peterjustesen-37e4f.appspot.com",
  messagingSenderId: "229307034358",
  appId: "1:229307034358:web:a722552bd9cfcbc4b4dad7"
};

export const app = firebase.initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const cloudfunction = getFunctions(app);

